import styles from "./FloatingActions.module.css";
import Icon from "./Icons";
import useSiteSettings from "../hooks/useSiteSettings";

const message = encodeURIComponent(
  "Hello Dr. Sharma, I'd like to book a physiotherapy consultation."
);

/**
 * Persistent contact rail: WhatsApp anchored left, call anchored right.
 * Icon-only — the accessible name comes from aria-label, not visible text.
 */
export default function FloatingActions() {
  const { doctor } = useSiteSettings();
  return (
    <div className={styles.wrap}>
      <a
        href={`https://wa.me/${doctor.whatsapp}?text=${message}`}
        className={`${styles.fab} ${styles.chat}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Message Dr. Aakash Sharma on WhatsApp at ${doctor.phone}`}
      >
        <span className={styles.iconWave}>
          <Icon name="whatsapp" size={24} />
        </span>
      </a>

      <a
        href={`tel:${doctor.phoneHref}`}
        className={`${styles.fab} ${styles.call}`}
        aria-label={`Call Dr. Aakash Sharma at ${doctor.phone}`}
      >
        <span className={styles.iconWave}>
          <Icon name="phone" size={24} />
        </span>
      </a>
    </div>
  );
}
